class JenvaraDeliveryEstimate {
  constructor(element) {
    this.element = element;
    this.output = element.querySelector('[data-jv-delivery-dates]');

    this.minimumDays = Number(element.dataset.minDays || 5);
    this.maximumDays = Number(element.dataset.maxDays || 8);

    this.render();
  }

  addBusinessDays(startDate, numberOfDays) {
    const result = new Date(startDate);
    let addedDays = 0;

    while (addedDays < numberOfDays) {
      result.setDate(result.getDate() + 1);

      const day = result.getDay();

      if (day !== 0 && day !== 6) {
        addedDays += 1;
      }
    }

    return result;
  }

  formatDate(date) {
    return new Intl.DateTimeFormat(
      document.documentElement.lang || 'en-AU',
      {
        weekday: 'short',
        day: 'numeric',
        month: 'short',
      }
    ).format(date);
  }

  render() {
    if (!this.output) return;

    const today = new Date();

    const earliestDate = this.addBusinessDays(
      today,
      this.minimumDays
    );

    const latestDate = this.addBusinessDays(
      today,
      Math.max(this.maximumDays, this.minimumDays)
    );

    this.output.textContent =
      `${this.formatDate(earliestDate)} – ${this.formatDate(latestDate)}`;
  }
}

function initialiseJenvaraDeliveryEstimates(root = document) {
  root
    .querySelectorAll(
      '[data-jv-delivery-estimate]:not([data-jv-delivery-initialised])'
    )
    .forEach((element) => {
      element.dataset.jvDeliveryInitialised = 'true';
      new JenvaraDeliveryEstimate(element);
    });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initialiseJenvaraDeliveryEstimates();
  });
} else {
  initialiseJenvaraDeliveryEstimates();
}

document.addEventListener('shopify:section:load', (event) => {
  initialiseJenvaraDeliveryEstimates(event.target);
});